<div class="app-content content">
  <div class="content-wrapper">
    <section class="row flexbox-container">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
          <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
            <div class="card-header border-0">
              <div class="card-title text-center">
                <h4>Join your team</h4>
                <p class="text-muted" *ngIf="invitedEmail">Setting up account for {{ invitedEmail }}</p>
              </div>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>
                <div *ngIf="successMessage" class="alert alert-success" role="alert">{{ successMessage }}</div>

                <form *ngIf="tokenValid && !successMessage" [formGroup]="form" (ngSubmit)="submit()">
                  <fieldset class="form-group">
                    <label for="fullName">Full name</label>
                    <input type="text" id="fullName" formControlName="fullName" class="form-control"
                           [ngClass]="{ 'is-invalid': submitted && f.fullName.errors }">
                    <div *ngIf="submitted && f.fullName.errors" class="invalid-feedback">Full name is required</div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="password">Choose a password</label>
                    <input type="password" id="password" formControlName="password" class="form-control"
                           [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                    <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                      Password must be at least 8 characters and include an uppercase letter, a lowercase letter, and a digit.
                    </div>
                  </fieldset>
                  <button type="submit" class="btn btn-outline-info btn-block" [disabled]="loading">
                    <i class="fa fa-refresh fa-spin" *ngIf="loading"></i> Create Account
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
